import { z } from "zod";

import { apiGet, apiPost } from "../lib/api";

export const ConfigEntrySchema = z.object({
  key: z.string(),
  label: z.string(),
  domain: z.string(),
  value: z.string(),
});
export const SecretStatusSchema = z.object({
  key: z.string(),
  label: z.string(),
  domain: z.string(),
  services: z.array(z.string()),
  settable: z.boolean(),
  take_effect: z.string(),
  coupled_warning: z.string().nullable(),
  configured: z.boolean().nullable(),
  last_rotated: z.string().nullable(),
});
export const WorkerConfigEntrySchema = z.object({ key: z.string(), note: z.string() });
export const SettingsResponseSchema = z.object({
  config: z.array(ConfigEntrySchema),
  secrets: z.array(SecretStatusSchema),
  worker_config_inventory: z.array(WorkerConfigEntrySchema),
});
export type SettingsResponse = z.infer<typeof SettingsResponseSchema>;
export type SecretStatus = z.infer<typeof SecretStatusSchema>;

export function fetchSettings() {
  return apiGet("/api/settings", SettingsResponseSchema);
}

// Slice 2/3 (defined now so the hook layer is stable; endpoints land later).
export const SecretSetResponseSchema = z.object({
  configured: z.boolean(),
  last_rotated: z.string().nullable(),
});
export function setSecret(key: string, value: string) {
  return apiPost(`/api/settings/secrets/${key}`, SecretSetResponseSchema, { value });
}
export const RestartResponseSchema = z.object({ service: z.string(), deployment_id: z.string() });
export function restartService(service: string) {
  return apiPost(`/api/settings/restart/${service}`, RestartResponseSchema, {});
}
